/** @jsx jsx */
import { jsx } from 'theme-ui'
import Lottie from 'lottie-react'
import { Container } from '../container'
import { lottieAnimation } from './animation'

const Hero = (props) => (
  <div
    sx={{
      background: 'primary',
      color: '#F5F5F5',
      width: '100%',
      pt: 48,
      pb: [32, 48],
      minHeight: [0, 0, 496]
    }}
  >
    <Container>
      <div
        sx={{
          display: 'flex',
          flexDirection: ['column', 'column', 'row'],
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <div
          className="animate__animated animate__fadeIn"
          sx={{ width: ['100%', '100%', '45%'] }}
        >
          <h1 sx={{ fontSize: [40, 56], lineHeight: '60px' }}>
            Uswitch Telecoms Awards 2024
          </h1>
          <p
            sx={{
              fontSize: ['18px', '24px'],
              lineHeight: '30px',
              color: '#D2D2D2'
            }}
          >
            {props.subtitle ||
              'Recognising the broadband, TV and mobile providers that powered our customers’ lives this past year.'}
          </p>
          <p
            sx={{
              fontSize: ['18px', '24px'],
              lineHeight: '30px',
              color: '#D2D2D2',
              fontWeight: 700
            }}
          >
            {props.schedule}
          </p>
        </div>

        <div sx={{}}>
          <Lottie animationData={lottieAnimation} loop />
        </div>
      </div>
    </Container>
  </div>
)

export default Hero
